const REPLACE_TEXT_TO_RICH_TEXT_EDITOR_STATE_EVENT = 'REPLACE_TEXT_TO_RICH_TEXT_EDITOR_STATE_EVENT';

function fireReplaceTextToRichTextEditorStateEvent(eventDetail: ReplaceTextToRichTextEditorStateEvent) {
    if (!('textToReplace' in eventDetail || 'eventListenerKey' in eventDetail)) {
        // console.error('fireReplaceTextToRichTextEditorStateEvent, eventDetail is not valid:', eventDetail);
        return;
    }
    window.dispatchEvent(
        new CustomEvent<ReplaceTextToRichTextEditorStateEvent>(REPLACE_TEXT_TO_RICH_TEXT_EDITOR_STATE_EVENT, {
            detail: eventDetail,
            bubbles: true
        })
    );
}

export { fireReplaceTextToRichTextEditorStateEvent, REPLACE_TEXT_TO_RICH_TEXT_EDITOR_STATE_EVENT };
